<template>
  <div :class="if_selected">
    <div slot="default" style="width: 100%">
      <div :class="title_component">
        <!-- possibility to replay only video with pointer_event:auto, default is "pointer_event:none" -->
        <div class="card" :style="this.config.attributes.style">
          <a
            v-if="this.config.attributes.link_poster"
            :href="linkPoster(poster)"
            target="_blank"
          >
            <img class="card-img-top" :src="src_poster" alt="Card image cap" />
          </a>
          <img
            v-else
            class="card-img-top"
            :src="src_poster"
            alt="Card image cap"
          />

          <div class="card-body">
            <p class="card-text">
              <Message class="h5 m-1" :msg="`${caption}`"></Message>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Message from "ireal-vue/components/MessageComponent.vue";
import dataComponentMixin from "ireal-vue/mixins/data-component-mixin.js";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import Bus from "../services/bus.js";

export default {
  name: "poster-component",
  mixins: [dataComponentMixin, inputComponentMixin],
  components: { Message },
  data() {
    return {
      poster: "",
      src_poster: "",
      list_model: [],
      if_selected: "",
    };
  },
  async created() {
    this.definitions = this.config.elements;
    this.caption = this.attributes.text
  },
  async mounted() {
    this.update_selected();
    Bus.$on("selected-changed", () => {
      this.update_selected();
    });
    this.list_model = this.setModelPoster();
    this.setPoster(this.poster);
    // Configure player source
    // Change poster on value changes
    Bus.$on("value-changed", async (payload) => {
      this.poster = payload.param;
      this.poster = "";
      this.list_model.forEach((element) => {
        return (this.poster = this.poster.concat(
          this.$store.getters.testParams[`${element}`]
        ));
      }, this);
      this.linkPoster(this.poster);
      this.setPoster(this.poster);
    });
  },
  computed: {
    caption() {
      return this.attributes.text;
    },
  },
  methods: {
    prepare() {},
    setModelPoster() {
      if (this.attributes.poster === undefined) return [];
      else return this.attributes.poster.split("|");
    },
    setPoster(value) {
      value = value ? `${value}` : "";
      this.src_poster = `${this.IREALCONFIG.static_ressources}/labs/${this.$store.getters.experienceIdentifier}/${value}_poster.jpg`;
    },
    setCaption(value) {
      this.caption = this.attributes.text;
    },
    OpenLink(event, i, c) {
      this.$store.commit("changeSrcVideo", event);
    },
    linkPoster(poster) {
      if (this.attributes.link_poster) {
        return `${this.IREALCONFIG.static_ressources}/labs/${this.$store.getters.experienceIdentifier}/${poster}_poster.${this.attributes.link_poster}`;
      } else {
        return null;
      }
    },
  },
};
</script>
<style scoped>
.portrait {
  min-height: 50vh !important;
}
</style>
<style src="video.js/dist/video-js.css"></style>
